import LocalCache from '@/utils/LocalCache';

import * as types from './mutation-types';

const mutations = {
  [types.MARK_AS_AUTHENTICATED](state) {
    state.authenticated = true;
    LocalCache.set('authenticated', 'true');
  },
  [types.MARK_AS_LOGGED_OUT](state) {
    state.authenticated = false;
    state.user = {};
    LocalCache.remove('authenticated');
  },
  [types.UPDATE_USER](state, user) {
    state.user = user;
  },
  [types.UPDATE_USER_PROFILE](state, userProfile) {
    state.userProfile = userProfile;
  },
  [types.UPDATE_MEMBERSHIP](state, membership) {
    state.membership = membership;
  },
  [types.UPDATE_IS_APP_OFFLINE](state, isAppOffline) {
    state.isAppOffline = isAppOffline;
  },
  [types.UPDATE_IS_NEW_VERSION_AVAILABLE](state, isNewVersionAvailable) {
    state.isNewVersionAvailable = isNewVersionAvailable;
  },
  [types.UPDATE_IS_PUBLIC_ROUTE](state, isPublicRoute) {
    state.isPublicRoute = isPublicRoute;
  },
  [types.UPDATE_USER_ROLE](state, userRole) {
    state.userRole = userRole;
  },
  [types.UPDATE_TOKEN](state, token) {
    state.token = token;
  },
  [types.UPDATE_REFRESH_TOKEN](state, refreshToken) {
    state.refreshToken = refreshToken;
  },
  [types.UPDATE_FRESHDESK_TOKEN](state, freshdeskToken) {
    state.freshdeskToken = freshdeskToken;
  },
  [types.SET_CHOSEN_MEMBERSHIP_TYPE](state, type) {
    state.chosenMembershipType = type;
  },
  [types.SET_DEBUG_MODE](state, debugMode) {
    state.debugMode = debugMode;
  },
  [types.UPDATE_BACKGROUND_OPERATIONS](state, backgroundOperations) {
    state.backgroundOperations = backgroundOperations;
  },
};

export default mutations;
